import { render } from "./WordCounter.vue?vue&type=template&id=3c29140c"
import script from "./WordCounter.vue?vue&type=script&lang=js"
export * from "./WordCounter.vue?vue&type=script&lang=js"

import "./WordCounter.vue?vue&type=style&index=0&id=3c29140c&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__